import React, { useState, useEffect } from "react";
import {
    Container,
    TextField,
    Button,
    Typography,
    Grid,
    Paper,
    IconButton,
    Divider,
    Box,
} from "@mui/material";
import { AddCircle, RemoveCircle } from "@mui/icons-material";
import axios from "axios";
import authService from "../Auth/AuthService";

const MarksheetForm = ({ marksheets, classRoomid, onSuccess }) => {
    const [form, setForm] = useState({
        classRoomId: classRoomid,
        examType: "",
        academicYear: "",
        remarks: "",
        marks: [
            { subjectName: "", marksObtained: "", maxMark: "", grade: "", remark: "" },
        ],
    });

    useEffect(() => {
        if (marksheets) {
            setForm(...marksheets)
        }
    }, [marksheets]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleMarkChange = (index, e) => {
        const updatedMarks = [...form.marks];
        updatedMarks[index][e.target.name] = e.target.value;
        setForm({ ...form, marks: updatedMarks });
    };

    const addSubject = () => {
        setForm({
            ...form,
            marks: [...form.marks, { subjectName: "", marksObtained: "", maxMarks: "", grade: "", remarks: "" }],
        });
    };

    const removeSubject = (index) => {
        const updatedMarks = form.marks.filter((_, i) => i !== index);
        setForm({ ...form, marks: updatedMarks });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (marksheets) {
                const formatted = marksheets.map(m => ({
                    id: m.id,
                    academicYear: m.academicYear,
                    examType: m.examType,
                    classRoomId: m.classRoom?.classId || null,
                    marks: m.marks,
                    remarks: m.remarks,
                }));
                const url = authService.pathUrl('PUT', '/marksheets');
                authService.putAuth(url, ...formatted);
            } else {
                const url = authService.pathUrl('POST', '/marksheets');
                authService.postAuth(url, form);
            }
            // alert("Marksheet saved successfully");
            if (onSuccess) onSuccess();
        } catch (err) {
            console.error(err);
            alert("Error saving marksheet");
        }
    };

    return (
        <Box>
            {/* <Paper sx={{ p: 2 }}> */}
            {/* <Typography variant="h5" gutterBottom>
                    {marksheetId ? "Update Marks" : "Add Marks"}
                </Typography> */}
            <Divider sx={{ mb: 3 }} />
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <TextField
                            required
                            label="Exam Type final/first/second"
                            name="examType"
                            value={form.examType}
                            onChange={handleChange}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            required
                            label="Academic Year 2024-2025"
                            name="academicYear"
                            value={form.academicYear}
                            onChange={handleChange}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            label="Remarks"
                            name="remarks"
                            value={form.remarks}
                            onChange={handleChange}
                            fullWidth
                        // multiline
                        />
                    </Grid>
                </Grid>

                <Typography variant="h6" sx={{ mt: 3 }}>
                    Subjects & Marks
                </Typography>
                <Divider sx={{ mb: 3 }} />
                {form.marks.map((mark, index) => (
                    <Grid container spacing={2} mb={2} alignItems="center" key={index}>
                        <Grid item xs={2}>
                            <TextField
                                required
                                label="Subject"
                                name="subjectName"
                                value={mark.subjectName}
                                onChange={(e) => handleMarkChange(index, e)}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                required
                                label="Obtained"
                                name="marksObtained"
                                type="number"
                                value={mark.marksObtained}
                                onChange={(e) => handleMarkChange(index, e)}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                required
                                label="Max Mark"
                                name="maxMark"
                                type="number"
                                value={mark.maxMark}
                                onChange={(e) => handleMarkChange(index, e)}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                placeholder="Write Remark or Non"
                                label="Remark/Non-Acadmic"
                                name="remark"
                                value={mark.remark}
                                onChange={(e) => handleMarkChange(index, e)}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton color="error" onClick={() => removeSubject(index)}>
                                <RemoveCircle />
                            </IconButton>
                        </Grid>
                    </Grid>
                ))}

                <Button startIcon={<AddCircle />} onClick={addSubject} sx={{ mt: 2, color: '#1b1914', fontWeight: 'bold' }}>
                    Add Subject
                </Button>

                <Button type="submit" variant="contained" sx={{ mt: 3, ml: 2, bgcolor: '#1b1914', borderRadius: 5 }}>
                    Save
                </Button>
            </form>
        </Box>
    );
};

export default MarksheetForm;
